module.exports = __webpack_public_path__ + "media/images/icons/country_flags/il-1e6c2f0e584f3e9eeceba2d0b7ba1de5.svg";